import type { Output, OutputPatch } from "./types";

export const BRIEF_STEPS = [
  { id: "outlet", label: "Target Outlet" },
  { id: "guidance", label: "General guidance" },
] as const;

export type BriefStepId = (typeof BRIEF_STEPS)[number]["id"];

export const isBriefStep = (value: string | null): value is BriefStepId => BRIEF_STEPS.some((s) => s.id === value);

/** PATCH the output with the current version; resolves `true` once saved, `false` on failure (already toasted). */
export type SaveOutput = (patch: Omit<OutputPatch, "version">, options?: { toastOnSuccess?: boolean }) => Promise<boolean>;

export interface BriefStepProps {
  output: Output;
  save: SaveOutput;
  saving: boolean;
  /** Unsaved edits on this step — drives the leave-page warning. */
  onDirtyChange: (dirty: boolean) => void;
  /** Saved (or nothing to save): move on. */
  onContinue: () => void;
}
